export default __webpack_public_path__ + "static/media/AcornMallCarpark_31.3144f847.png";